import handleException from '../../../Core/Helpers/handleException';
import { getItemDescriptions } from '../../../HttpRequests/itemDescriptions';
import { setFetching } from '../State/fetching';
import { loadItemDescriptions } from '../State/itemDescriptions';
import { setPagination } from '../State/pagination';

export default () => async (dispatch, getState) => {

  const { pagination, searchTerm } = getState().screens.ItemDescriptions;

  try {

    const params = {};
    
    params['page[size]'] = pagination.pageSize;
    params['page[number]'] = pagination.current;

    if (searchTerm) {
      params.search = searchTerm;
    }
    
    params.csort =  '-id';

    dispatch(setFetching(true));

    const response = await getItemDescriptions({ params });
    const itemDescriptions = response.data;

    dispatch(loadItemDescriptions(itemDescriptions.data));
    
    dispatch(setPagination({
      total: itemDescriptions.pagination.total,
      pageSize: itemDescriptions.pagination.per_page,
      current: itemDescriptions.pagination.current_page
    }));

    dispatch(setFetching(false))

  } catch (error) {

    handleException(error);

    dispatch(setFetching(false))
  }
}